var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action } from 'mobx';
import useStore from '@/common/hooks/useStore';
import Storage, { KEY_URI_AFTER_TOP_UP } from '@/common/services/Storage';
import BillingAPI from '../api/BillingAPI';
export default class BillingStore {
    billingAPI;
    constructor() {
        this.billingAPI = new BillingAPI();
    }
    topUpBalance = (amount) => {
        return this.billingAPI.getPaymentEnroll(amount).then((response) => {
            /**
             * Save current location, after payment user will be redirected to result page, on result page we will take url from storage
             * and redirect user to his previous location
             *
             * Check "TopUpResult.tsx"
             * */
            if (response.content?.redirect) {
                Storage.saveObject(KEY_URI_AFTER_TOP_UP, window.location.href, Storage.STORAGE_SESSION);
                window.location.href = response.content.redirect;
            }
        });
    };
}
__decorate([
    action
], BillingStore.prototype, "topUpBalance", void 0);
export const useBillingStore = () => useStore(BillingStore);
export const billingStore = new BillingStore();
